<div class="policy-category disabled">

  <div class="policy-item">

    <i class="policy-number">1</i>
    <radio-question [data]="cancelling.data" [valueSelected]="cancelling.valueSelected"
                    (selectAnswer)="onCancellingSelected($event)"></radio-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">2</i>
    <div class="default-text large" [innerHTML]="textCopy.contraventionsTitle"></div>
    <div class="default-text" [innerHTML]="textCopy.contraventionsText"></div>
    <contraventions-question [valuesSelected]="contraventions.valuesSelected"
                             [options]="contraventions.options"
                             (selectAnswer)="onContraventionsSelected($event)"
                             [active]="cancelling.valueSelected === 'y'"></contraventions-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">3</i>
    <select-question [data]="cancellationsNumber.data" [active]="cancelling.valueSelected === 'y'"
                     [valueSelected]="cancellationsNumber.valueSelected"
                     (selectAnswer)="onCancellationsNumberSelected($event)"></select-question>
  </div>

  <br />
  <div class="submit-layer">
    <input aria-label=""  type="submit" class="app-submit" value="Save"
           (click)="submitPolicyCategory()" />
  </div>

</div>
